/* eslint-disable @angular-eslint/directive-selector */
import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {ClickListenerService} from '../services/click-listener.service';

@Directive({
  selector: '[registerMenuToggle]',
  standalone: false,
})
export class RegisterMenuToggleDirective implements OnInit, OnDestroy {
  @Output() clickedOutside = new EventEmitter<HTMLElement>();
  private subscriptions: Subscription[] = [];

  constructor(
    private el: ElementRef,
    private clickListener: ClickListenerService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.clickListener.clickedOutsideElement$(this.el.nativeElement).subscribe(() => {
        if (document.getElementsByClassName('modal-container').length > 0) {
          return;
        }
        this.clickedOutside.emit(this.el.nativeElement);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
